import './index.css';
import { PopulatedDatabaseWatchParty } from '@fake-stack-overflow/shared/types/watch';

interface Props {
  party: PopulatedDatabaseWatchParty;
  onJoin: (id: string) => void;
}

const WatchpartyCard = ({ party, onJoin }: Props) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _id, name, host, currentVideo, videoQueue, isOver } = party;

  return (
    <div className='watchparty-card' onClick={() => onJoin(_id.toString())}>
      <h3>{name}</h3>
      <h4>Host: {host}</h4>
      <p>
        <strong>Now Watching:</strong> {currentVideo?.title || <em>Nothing yet</em>}
      </p>
      <p>
        <strong>Queue:</strong> {videoQueue.length} videos
      </p>
      <p className={isOver ? 'status-ended' : 'status-live'}>{isOver ? 'Ended' : 'Live'}</p>
    </div>
  );
};

export default WatchpartyCard;
